import React from 'react';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';
import { usePatchApplication } from '~/data/useApplication';

export function useConfirmEnrolmentActivity() {
  const process = useAppProcessing();

  const { patchApplication } = usePatchApplication(process.application.id);
  const [isBusy, setIsBusy] = React.useState(false);

  async function confirmEnrolment() {
    setIsBusy(true);
    return patchApplication({ status: 'ENROLMENT_CONFIRMED' }).finally(() => setIsBusy(false));
  }

  return {
    isBusy,
    confirmEnrolment,
    completeProcess: () => process.completeProcess(),
  };
}
